import { useAuth0 } from '@auth0/auth0-react';
import { datadogLogs } from '@datadog/browser-logs';
import { BlankScreen } from '@strata/react-page-templates';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { fmhAPI } from 'api/APIBase';
import { getFmhToken } from 'api/authAPI';
import { LOGIN_REDIRECT_KEY } from 'services/constants';
import { handleError } from 'services/Error';
import { AppRoutes } from 'services/routes';
import { SocketType, wsConnect } from 'services/socketHelpers';
import { setNpi } from 'store/auth/authSlice';

/**
 * Component to be rendered on callback from Auth0.
 * Handles authentication of the user and redirects to /home.
 */
export const AuthCallback = () => {
    const { isLoading, user, getAccessTokenSilently } = useAuth0();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        void (async () => {
            if (!isLoading) {
                try {
                    const fmhTokenResult = await getFmhToken({
                        accessToken: await getAccessTokenSilently(),
                    });

                    const accessToken = fmhTokenResult.access_token;
                    const selectedNpi = fmhTokenResult.npi;
                    fmhAPI.base = fmhAPI.base.auth(`Bearer ${accessToken}`);

                    dispatch(
                        setNpi({
                            accessToken,
                            selectedNpi,
                            permissions: fmhTokenResult.permissions,
                        }),
                    );

                    dispatch(wsConnect({ socketType: SocketType.NOTIFICATION, npi: selectedNpi }));

                    datadogLogs.logger.info('User Authenticated', { user });
                } catch (err) {
                    handleError('Error authenticating.', err);
                } finally {
                    const redirectPath = sessionStorage.getItem(LOGIN_REDIRECT_KEY);
                    navigate(redirectPath ?? AppRoutes.home);
                }
            }
        })();
    }, [isLoading, user, dispatch, getAccessTokenSilently, navigate]);

    return <BlankScreen />;
};
